import { createSlice } from "@reduxjs/toolkit";
import {
  showApprovalAll,
  showApprovalSettingDepartment,
  showApprovalSettingEmployee,
  createApprovalSetting,
} from "../actions";

const initialState = {
  approval: [],
  approvalSettingEmployee: [],
  approvalSettingDepartment: [],
};

const approvalSlice = createSlice({
  name: "approval",
  initialState,
  reducers: {},
  extraReducers: {
    [showApprovalSettingDepartment.fulfilled]: (state, action) => {
      state.approvalSettingDepartment = action.payload || [];
    },
    [showApprovalSettingEmployee.fulfilled]: (state, action) => {
      state.approvalSettingEmployee = action.payload || [];
    },
    [createApprovalSetting.fulfilled]: (state, action) => {
      state.approvalAll = action.payload || [];
    },
    [showApprovalAll.fulfilled]: (state, action) => {
      state.approvalAll = action.payload || [];
    },
  },
});

export const responseApproval = (state) => state.approval;

export default approvalSlice.reducer;
